// extracted by mini-css-extract-plugin
export default {"input":"bug-field_input__UHFOu","inpInner":"bug-field_inpInner__zcEXE"};